import { addDays, formatYMD } from './dates.js'

export interface PrefillField {
  value: string
  source: string
}

export interface Persona {
  id: string
  name: string
  address: { line1: string; city: string; state: string; zip: string }
  property: { type: string; floor: string; yearBuilt: number; sqft: number }
  prefill: {
    cabinetWidth: PrefillField
    countertop: PrefillField
    flooring: PrefillField
  }
  order: {
    number: string
    appliance: string
    estimatedInstall: string   // YYYY-MM-DD, computed at module load (~two weeks from now)
  }
  technician: { name: string; initials: string; rating: number }
}

const TODAY = new Date()
const EST_INSTALL = formatYMD(addDays(TODAY, 14))

export const SARAH: Persona = {
  id: 'sarah',
  name: 'Sarah Mitchell',
  address: { line1: '4521 Maple Drive', city: 'Bentonville', state: 'AR', zip: '72712' },
  property: { type: 'Single-Family Home', floor: 'Ground floor', yearBuilt: 2004, sqft: 2450 },
  prefill: {
    cabinetWidth: { value: '24"', source: 'From 2023 installation' },
    countertop:   { value: 'Granite', source: 'From Zillow listing' },
    flooring:     { value: 'Hardwood', source: 'From Zillow listing' },
  },
  order: {
    number: '882194',
    appliance: 'Whirlpool 24" Built-In Dishwasher',
    estimatedInstall: EST_INSTALL,
  },
  technician: { name: 'James Chen', initials: 'JC', rating: 4.9 },
}

export const activePersona = (): Persona => {
  // Only one persona today; the URL param exists for future extensibility.
  return SARAH
}
